import {Component, EventEmitter, Input, OnInit, Output, ViewChildren} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Media} from 'storyboard-renderer';
import {MediaLibraryService} from '../../shared/media-library.service';

@Component({
  selector: 'app-media-item',
  templateUrl: './media-item.component.html',
  styleUrls: ['./media-item.component.scss']
})
export class MediaItemComponent implements OnInit {

  @Input() item;
  @Input() userId = null;
  @Output() deleteMediaEvent = new EventEmitter();
  @Output() selectMediaEvent = new EventEmitter();

  tmpMediaTitle: string;

  @ViewChildren('editMediaInput') vc;

  constructor(private router: Router, private mediaLibraryService: MediaLibraryService) {
  }

  ngOnInit() {
  }

  delete(event) {
    event.stopPropagation();

    this.deleteMediaEvent.next(this.item);
    return false;
  }

  stopProp($event) {
    $event.stopPropagation();
  }

  editMode(event, media: Media) {
    event.stopPropagation();

    media.editing = true;
    this.tmpMediaTitle = media.title;

    const self = this;
    setTimeout(function() {
      self.vc.first.nativeElement.focus();
    }, 500);
  }

  selectMedia($event, media: Media) {
    if (this.item.editing) {
      return;
    }

    this.selectMediaEvent.next(media);
  }

  save(event, media: Media) {
    event.stopPropagation();

    if (!this.tmpMediaTitle) {
      return;
    }

    media.title = this.tmpMediaTitle;

    this.mediaLibraryService.update(media, {userId: this.userId}).then(() => {
      media.editing = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/media-library/browse-media/media-item/media-item.component.ts